/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/extensions */
/* eslint-disable no-else-return */
import React, {
    useState,
    useEffect,
    useCallback,
    useContext
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { ServiceManager } from '@jutro/services';
import { withRouter } from 'react-router-dom';
import {
    Loader, ModalNextProvider, Icon
} from '@jutro/components';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { IntlContext } from '@jutro/locale';
import {
    Claim, SasriaInsuredCompany, SasriaInsuredCompanyCreate, SasriaInsuredContactCreate, SasriaInsuredContact
} from 'gw-capability-fnol-common-react';
import { LobIconUtil } from 'gw-portals-util-js';
import { getSasriaNormalizedLOBName } from 'gw-portals-config-js';
import { messages as commonMessages } from 'gw-platform-translations';

import { useValidation } from 'gw-portals-validation-react';

import { useAuthentication } from 'gw-digital-auth-react';
import InsuredSearch from 'gw-capability-fnol-common-react/models/InsuredSearch.js';
import { validateEffectiveAndExpiryDates, lossDateValidation } from 'sasria-capability-fnol-common-react/Validations/ValidationUtil';
import moment from 'moment';
import FNOLPolicySearchModal from '../../components/FNOLPolicySearchModal/FNOLPolicySearchModal';
import styles from './FNOLSelectPolicy.module.scss';
import metadata from './FNOLSelectPolicy.metadata.json5';
import messages from './FNOLSelectPolicy.messages';


import icon from './icon/persondark.png';

function FNOLSelectPolicy(props) {
    const {
        onValidate,
        isComponentValid,
        registerComponentValidation,
    } = useValidation('FNOLSelectPolicy');

    const {
        wizardData: claimVM,
        history,
        steps,
        goNext,
        basePath,
        updateWizardData,
        history: {
            location: { state }
        }
    } = props;

    const {
        redirectPath,
        claimNumber,
        claimStatus
    } = state || {};

    const { FNOLService } = useDependencies('FNOLService');
    const { ClaimService } = useDependencies('ClaimService');
    const [isLoading, setIsLoading] = useState(true);
    const [policyNumberFromFlow, sePolicyNumberFromFlow] = useState('');
    const [hasFlowBeenEntered, setHasFlowBeenEntered] = useState(false);
    const [hasSearchBeenTriggered, setHasSearchBeenTriggered] = useState(false);
    const [policyList, setPolicyList] = useState([]);
    const [policySearchCriteriaVM, setPolicySearchCriteriaVM] = useState({});
    const [sasriaClassCodeValue, setSasriaClassCodeValue] = useState('');
    const [sasriaClassCodeData, setSasriaClassCodeData] = useState([]);
    const [insuredList, setInsuredList] = useState([]);
    const [createInsured, showCreateInsured] = useState(false);
    const [insuredSearchVM, setInsuredSearchVM] = useState({});
    const [insuredCreateVM, setInsuredCreateVM] = useState({});
    const [insuredType, setInsuredType] = useState('InsuredCompany_EXT');
    const [showCreateDiv, setShowCreateDiv] = useState(false);
    const [selectedInsured, setSelectedInsured] = useState();
    const [hideNext, setHideNext] = useState(true);

    const intl = useContext(IntlContext);
    const viewModelService = useContext(ViewModelServiceContext);

    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();

    const clearInsuredSearchValues = useCallback((value) => {
        setInsuredType(value);
    }, []);

    const getInsuredTypeComponent = useCallback((value) => {
        setInsuredType(value);
    }, []);

    const isClaimSelectionValid = useCallback(() => {
        return !(
            (claimVM.lossDate && !claimVM.lossDate.aspects.valid)
            || (claimVM.policy && claimVM.policy.aspects && !claimVM.policy.aspects.valid)
            || (claimVM.policy && claimVM.policy.aspects && !claimVM.policy.aspects.subtreeValid)
            || (claimVM.policy && _.isEmpty(claimVM.policy.value))
        );
    }, [claimVM.lossDate, claimVM.policy]);

    const getClassCodefilter = useCallback((classCode) => {
        return classCode.map((key) => {
            return {
                code: key,
                name: key
            };
        });
    }, []);

    const retrieveSasriaClassCodes = useCallback(() => {
        if (sasriaClassCodeData && sasriaClassCodeData.length >= 1) {
            return sasriaClassCodeData;
        }
        return FNOLService.getSasriaClassCodes(authHeader)
            .then((sasriaClassCodes) => {
                const sasriaClassCodesDataArray = getClassCodefilter(sasriaClassCodes);
                setSasriaClassCodeData(sasriaClassCodesDataArray);
            });
    }, [FNOLService, authHeader, getClassCodefilter, sasriaClassCodeData]);

    useEffect(() => {
        if (!_.isEmpty(claimVM.value, 'policy') && !_.isEmpty(claimVM.value.policy, 'policyNumber')) {
            setHasFlowBeenEntered(true);
            sePolicyNumberFromFlow(_.get(claimVM.value, 'policy.policyNumber'));
        }

        const localeService = ServiceManager.getService('locale-service');
        setPolicySearchCriteriaVM(viewModelService.create(
            { country: localeService.getDefaultCountryCode() }, 'cc',
            'edge.capabilities.claim.fnol.policy.dto.PolicySearchCriteriaDTO'
        ));

        const insuredSearchViewModel = viewModelService.create(
            _.get(policySearchCriteriaVM.value, 'insured_EXT') || new InsuredSearch(),
            'cc',
            'edge.capabilities.extusermgmt.insuredsearch.dto.InsuredSearchCriteriaDTO_EXT'
        );

        const insuredCreateViewModel = viewModelService.create(
            _.get(policySearchCriteriaVM.value, 'createInsured_EXT') || new InsuredSearch(),
            'cc',
            'edge.capabilities.extusermgmt.insuredsearch.dto.InsuredSearchCriteriaDTO_EXT'
        );

        retrieveSasriaClassCodes();
        setInsuredSearchVM(insuredSearchViewModel);
        setInsuredCreateVM(insuredCreateViewModel);
        setIsLoading(false);
        // execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        registerComponentValidation(isClaimSelectionValid);
    }, [isClaimSelectionValid, registerComponentValidation]);

    const redirectDraftClaimFlow = useCallback(() => {
        setIsLoading(true);
        if (_.isFunction(ClaimService.addRecentlyViewedClaim)) {
            ClaimService.addRecentlyViewedClaim(claimNumber, authHeader);
        }
        return FNOLService.getClaim(claimNumber, authHeader).then((getClaimResponse) => {
            claimVM.value = getClaimResponse;
            const policy = _.get(claimVM, 'policyData_EXT.value');
            const sasriaClassCode = _.get(policy, 'sasriaClassCode_EXT');
            const normalizedSasriaLOBCode = getSasriaNormalizedLOBName(sasriaClassCode);
            // const normalizedLobCode = getNormalizedLOBName(claimVM.value.policy.policyType);
            // const tempLobCodes = ['f', 'f4', 'fe3', 'm', 'bi', 'git'];
            return history.push({
                // pathname: `/fnol-${normalizedLobCode}`,
                pathname: `/sasria-fnol-${normalizedSasriaLOBCode}-flow`,
                state: {
                    claimData: getClaimResponse,
                    redirectPath: redirectPath,
                    claimStatus: claimStatus
                }
            });
        });
    }, [ClaimService, FNOLService, claimNumber, authHeader, claimVM, history, redirectPath, claimStatus]);

    const handleClassCodeChange = useCallback(
        (classCodeIndex) => {
            _.set(policySearchCriteriaVM.value, 'sasriaClassCode_EXT', classCodeIndex);
            setSasriaClassCodeValue(classCodeIndex);
            updateWizardData(claimVM);
        },
        [claimVM, policySearchCriteriaVM.value, updateWizardData]
    );

    useEffect(() => {
        if (!_.isEmpty(claimNumber)) {
            redirectDraftClaimFlow();
        }
        const stepsWithoutSelectPolicy = steps.slice(1, steps.length);
        if (
            basePath !== '/fnol-select-policy'
            && !stepsWithoutSelectPolicy.some((step) => step.visited)
        ) {
            goNext();
        }
        // This will call only once.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handlePolicySelect = useCallback((selectedPolicyNumber) => {
        const policy = _.find(policyList, { policyNumber: selectedPolicyNumber });
        if (hasFlowBeenEntered) {
            if (policyNumberFromFlow !== selectedPolicyNumber) {
                ModalNextProvider.showConfirm({
                    title: messages.changePolicyModalTitle,
                    message: messages.changePolicyModalMessage,
                    status: 'warning',
                    icon: 'mi-error-outline',
                    confirmButtonText: messages.changePolicyModalConfirmationButtonText,
                    cancelButtonText: messages.changePolicyModalCancelButtonText
                    // eslint-disable-next-line consistent-return
                }).then((results) => {
                    if (results === 'cancel') {
                        return false;
                    }
                    claimVM.value = new Claim();
                    _.set(claimVM.value, 'policy', policy);
                    _.set(claimVM.value, 'policyData_EXT', policy);
                    setHideNext(false);
                    updateWizardData(claimVM);
                }, _.noop);
            }
        } else {
            _.set(claimVM, 'policy.value', policy);
            _.set(claimVM, 'policyData_EXT.value', policy);
            setHideNext(false);
            updateWizardData(claimVM);
        }
    },
    [claimVM, hasFlowBeenEntered, policyList, policyNumberFromFlow, updateWizardData]);

    const handleInsuredSelect = useCallback((selectedUID) => {
        const insured = _.find(insuredList, { uid: selectedUID });
        _.set(policySearchCriteriaVM, 'selectedInsured_EXT.value', insured);
        setSelectedInsured(insured);
        updateWizardData(claimVM);
    },
    [claimVM, insuredList, policySearchCriteriaVM, updateWizardData]);

    const handleError = (title, message) => {
        return ModalNextProvider.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    };

    const searchForAPolicy = useCallback(() => {
        const effective = _.get(policySearchCriteriaVM.value, 'effectiveDate_EXT');
        const expiration = _.get(policySearchCriteriaVM.value, 'expirationDate_EXT');

        if (!validateEffectiveAndExpiryDates(effective, expiration)) {
            return false;
        }
        return FNOLService.searchPolicies(policySearchCriteriaVM.value, authHeader)
            .then((policies) => {
                if (policies.length === 1) {
                    // if (claimVM.policy && !claimVM.policy.value) {
                    //     _.set(claimVM, 'policy.value', policies[0]);
                    //     _.set(claimVM, 'policyData_EXT.value', policies[0]);
                    // }
                    _.set(claimVM, 'policy.value', policies[0]);
                    _.set(claimVM, 'policyData_EXT.value', policies[0]);
                    setHideNext(false);
                }
                setHasSearchBeenTriggered(true);
                setPolicyList(policies);
            });
    }, [FNOLService, authHeader, claimVM, policySearchCriteriaVM.value]);

    const searchInsured = useCallback(() => {
        const insuredCriteria = _.get(policySearchCriteriaVM.value, 'insured_EXT');
        _.set(insuredCriteria, 'insuredType', insuredType);
        const { vatNo, regNo } = insuredCriteria;
        try {
            if (insuredType === 'InsuredCompany_EXT') {
                const vatRegex = new RegExp(/^(\d{10})?$/);
                if (!_.isUndefined(vatNo)) {
                    if (!vatRegex.test(vatNo)) {
                        // _.set(insuredCriteria, 'vatNo', undefined);
                        return handleError(
                            messages.vatNoValidationTitle,
                            messages.vatNoValidationMessage
                        );
                    }
                }
                if (!_.isUndefined(regNo)) {
                    const regRegex = new RegExp(/^(\d{1,14})?$/);
                    if (!isNaN(regNo) && !regRegex.test(regNo)) {
                        // _.set(insuredCriteria, 'regNo', undefined);
                        return handleError(
                            messages.regNoValidationTitle,
                            messages.regNoValidationMessage
                        );
                    }
                    if (isNaN(regNo)) {
                        const res = regNo.replaceAll('/', '-');
                        const re = new RegExp(/^([0-9]{4}-[0-9]{6}-[0-9]{2})$/);

                        if (!(re.test(res))) {
                            _.set(insuredCriteria, 'regNo', undefined);
                            return handleError(
                                messages.regNoValidationTitle,
                                messages.regNoValidationMessage
                            );
                        }
                    }
                }
            } else {
                const said = insuredCriteria.id;
                const passport = insuredCriteria.passportNumber;
                const saidRegex = new RegExp(/^(\d{13})?$/);
                if (!_.isNil(said) && (!saidRegex.test(said))) {
                    // _.set(insuredCriteria, 'id', undefined);
                    return handleError(
                        messages.idNoValidationTitle,
                        messages.idNoValidationMessage
                    );
                }
                if (!_.isNil(passport)) {
                    const re = new RegExp(/^([a-zA-Z0-9]{1,13})$/);
                    if (!re.test(passport) || passport.length > 13) {
                        // _.set(insuredCriteria, 'passportNumber', undefined);
                        return handleError(
                            messages.passportNoValidationTitle,
                            messages.passportNoValidationMessage
                        );
                    }
                }
            }

            return FNOLService.searchInsured(insuredCriteria, authHeader)
                .then((insureds) => {
                    if (insureds.length === 0) {
                        showCreateInsured(true);
                    } else {
                        showCreateInsured(false);
                    }
                    setInsuredList(insureds);
                });
        } catch (e) {
            return handleError(
                messages.errorSearchingInsuredTitle,
                messages.errorSearchingInsuredMessage
            );
        }
    }, [FNOLService, authHeader, policySearchCriteriaVM.value, insuredType]);


    // createinsured
    const createInsuredData = useCallback(() => {
        const insuredCriteria = _.get(policySearchCriteriaVM.value, 'insured_EXT');
        _.set(insuredCriteria, 'insuredType', insuredType);
        const { vatNo, regNo } = insuredCriteria;
        const isVatreq = insuredCriteria.vatRegistered;
        const insuredAddress = insuredCriteria.insuredAddress.city;
        try {
            if (_.isEmpty(insuredAddress)) {
                return handleError(
                    messages.addressMandatoryTitle,
                    messages.addressMandatoryMessage
                );
            }
            if (insuredType === 'InsuredCompany_EXT') {
                if (isVatreq && _.isUndefined(vatNo)) {
                    return handleError(
                        messages.vatNoMandatoryTitle,
                        messages.vatNoMandatoryMessage
                    );
                }

                const vatRegex = new RegExp(/^(\d{10})?$/);
                if (!_.isUndefined(vatNo)) {
                    if (!vatRegex.test(vatNo)) {
                        return handleError(
                            messages.vatNoValidationTitle,
                            messages.vatNoValidationMessage
                        );
                    }
                }
                if (!_.isUndefined(regNo)) {
                    const regRegex = new RegExp(/^(\d{1,14})?$/);
                    if (!isNaN(regNo) && !regRegex.test(regNo)) {
                        return handleError(
                            messages.regNoValidationTitle,
                            messages.regNoValidationMessage
                        );
                    }
                    if (isNaN(regNo)) {
                        const res = regNo.replaceAll('/', '-');
                        const re = new RegExp(/^([0-9]{4}-[0-9]{6}-[0-9]{2})$/);

                        if (!(re.test(res))) {
                            return handleError(
                                messages.regNoValidationTitle,
                                messages.regNoValidationMessage
                            );
                        }
                    }
                }
            } else {
                const said = insuredCriteria.id;
                const passport = insuredCriteria.passportNumber;
                const saidRegex = new RegExp(/^(\d{13})?$/);
                if (said !== undefined && (!saidRegex.test(said))) {
                    return handleError(
                        messages.idNoValidationTitle,
                        messages.idNoValidationMessage
                    );
                }
                if (passport !== undefined) {
                    const re = new RegExp(/^([a-zA-Z0-9]{1,13})$/);
                    if (!re.test(passport) || passport.length > 13) {
                        return handleError(
                            messages.passportNoValidationTitle,
                            messages.passportNoValidationMessage
                        );
                    }
                }
            }

            return FNOLService.createInsured(insuredCriteria, authHeader)
                .then((insureds) => {
                    setInsuredList(insureds);
                });
        } catch (e) {
            return handleError(
                messages.errorCreatingInsuredTitle,
                messages.errorCreatingInsuredMessage
            );
        }
    }, [FNOLService, authHeader, policySearchCriteriaVM.value, insuredType]);

    const searchPolicyBySearchCriteria = useCallback(async () => {
        _.set(policySearchCriteriaVM.value, 'policyNumber', undefined);
        await searchForAPolicy();
    }, [policySearchCriteriaVM.value, searchForAPolicy]);

    const setCreateButtonVisibility = useCallback(
        () => {
            setShowCreateDiv(!showCreateDiv);
            showCreateInsured(!createInsured);
        },
        [showCreateDiv, createInsured]
    );

    const searchPolicyByPolicyNumber = useCallback(async () => {
        const keywords = ['firstName', 'lastName', 'city', 'state', 'zip', 'policyType'];
        _.each(keywords, (keyword) => _.set(policySearchCriteriaVM.value, keyword, undefined));
        await searchForAPolicy();
    }, [policySearchCriteriaVM.value, searchForAPolicy]);

    const getFormattedDate = useCallback((items, index, property) => {
        return intl.formatDate(new Date(items[property.id]), { year: 'numeric', month: 'short', day: 'numeric' });
    }, [intl]);

    const getProductImage = useCallback((item) => {
        const productIcon = LobIconUtil.getFontIcon(item.policyType);
        return (
            <Icon
                icon={productIcon}
                title={item.policyType}
            />
        );
    }, []);

    const getCell = useCallback((item, index, property) => {
        return <span>{item[property.id]}</span>;
    }, []);

    const handlePolicyCriteriaVMChange = useCallback((newModel) => {
        setPolicySearchCriteriaVM(newModel);
        refreshData();
    }, [refreshData]);

    const showPolicySearchModal = useCallback(() => {
        ModalNextProvider.showModal(
            <FNOLPolicySearchModal
                viewModelService={viewModelService}
                searchPolicyBySearchCriteria={searchPolicyBySearchCriteria}
                policySearchCriteriaVM={policySearchCriteriaVM}
                handlePolicyCriteriaVMChange={handlePolicyCriteriaVMChange}
            />
        );
    }, [
        handlePolicyCriteriaVMChange,
        policySearchCriteriaVM,
        searchPolicyBySearchCriteria,
        viewModelService
    ]);

    const switchToManualSearchMode = useCallback(() => {
        showPolicySearchModal();
    }, [showPolicySearchModal]);

    const generateDataForRadioButton = useCallback((row) => {
        return {
            code: row.policyNumber,
            value: ''
        };
    }, []);

    const generateDataForInsuredRadioButton = useCallback((row) => {
        return {
            code: row.uid,
            value: ''
        };
    }, []);

    const shouldShowInfoNotification = useCallback(() => {
        return hasSearchBeenTriggered && policyList.length === 0;
    }, [hasSearchBeenTriggered, policyList.length]);

    const onNext = useCallback(() => {
        const policy = _.get(claimVM, 'policyData_EXT.value');
        const sasriaClassCode = _.get(policy, 'sasriaClassCode_EXT');
        const normalizedSasriaLOBCode = getSasriaNormalizedLOBName(sasriaClassCode);
        // const normalizedSasriaLOBCode = getSasriaNormalizedLOBName(claimVM.value.policyData_EXT.sasriaClassCode_EXT);
        // let normalizedLobCode = 'pa' ;
        // if(claimVM.value && claimVM.value.policy && claimVM.value.policy.policyType){
        //     normalizedLobCode = getNormalizedLOBName(claimVM.value.policy.policyType);
        // }

        const expDate = moment(policy.expirationDate).format(moment.HTML5_FMT.DATE);
        const effDate = moment(policy.effectiveDate).format(moment.HTML5_FMT.DATE);
        policy.expirationDate = new Date(expDate).setHours(0, 0, 0, 0);
        policy.effectiveDate = effDate;
        claimVM.value = new Claim();
        claimVM.value.policyData_EXT = policy;
        claimVM.value.policy = policy;
        claimVM.value.lossDate = policySearchCriteriaVM.lossDate.value;

        const effective = _.get(policySearchCriteriaVM.value, 'effectiveDate_EXT');
        const expiration = _.get(policySearchCriteriaVM.value, 'expirationDate_EXT');
        const lossDt = moment(_.get(policySearchCriteriaVM.value, 'lossDate')).format(moment.HTML5_FMT.DATE);

        if (!lossDateValidation(effective, expiration, lossDt)) return false;
        const { effectiveDate, expirationDate } = policy;
        if (!lossDateValidation(effectiveDate, expirationDate, lossDt)) return false;
        let duplicateClaimsFound = false;
        const insuredData = _.get(policy, 'insuredData_EXT');
        const insuredUid = _.get(insuredData, 'uid') ? _.get(insuredData, 'uid') : _.get(insuredData, 'uID');
        const agentUid = _.get(policy, 'agentUID_EXT');
        const agentPolicyNumber = _.get(policy, 'policyNumber');
        const agentClaimNumber = _.get(policy, 'agentClaimNumber_EXT');
        const classCode = _.get(policy, 'sasriaClassCode_EXT');
        const duplicateData = {
            lossDate: lossDt,
            insuredUid,
            agentUid,
            agentPolicyNumber,
            agentClaimNumber,
            classCode
        };
        FNOLService.checkIfDuplicateClaimExists_Ext(duplicateData, authHeader)
            .then((response) => {
                duplicateClaimsFound = response;
                _.set(claimVM.value, 'sasriaDuplicateClaimExists_EXT', duplicateClaimsFound);
                if (duplicateClaimsFound) {
                    updateWizardData(claimVM);
                    ModalNextProvider.showConfirm({
                        title: 'Warning',
                        message: 'There are possible duplicate claims already existing based on the details you have entered. You may proceed, however Express Claim option will not be available.',
                        status: 'warning',
                        icon: 'mi-error-outline',
                        confirmButtonText: 'Proceed',
                        cancelButtonText: 'Cancel'
                    }).then((results) => {
                        if (results === 'cancel') {
                            return _.noop();
                        }
                        return history.push({
                            pathname: `/sasria-fnol-${normalizedSasriaLOBCode}-flow`,
                            state: {
                                claimData: claimVM.value,
                                redirectPath: redirectPath
                            }
                        });
                    }, _.noop);
                } else {
                    updateWizardData(claimVM);
                    return history.push({
                        pathname: `/sasria-fnol-${normalizedSasriaLOBCode}-flow`,
                        state: {
                            claimData: claimVM.value,
                            redirectPath: redirectPath
                        }
                    });
                }
                return claimVM;
            })
            .catch((err) => {
                ModalNextProvider.showAlert({
                    title: 'Error',
                    message: 'Error: There is an error initiating the claim, please try again.',
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                return false;
            })
            .finally(() => {
                setIsLoading(false);
            });
        return claimVM;
    }, [FNOLService, authHeader, claimVM, history, policySearchCriteriaVM, redirectPath, updateWizardData]);

    const createInsuredButtonDisabled = () => {
        const insuredAddress = _.get(insuredCreateVM.value, 'insuredAddress');
        const insuredCity = _.get(insuredAddress, 'city');
        if (insuredType === 'InsuredCompany_EXT') {
            const compName = _.get(insuredCreateVM.value, 'companyName');
            // const regNo = _.get(insuredCreateVM.value, 'regNo');
            const isVat = _.get(insuredCreateVM.value, 'vatRegistered');
            const vatNo = _.get(insuredCreateVM.value, 'vatNo');
            return !((compName && compName.length >= 3) && (isVat ? vatNo : true) && insuredCity);
        } else if (insuredType === 'InsuredContact_Ext') {
            const firstName = _.get(insuredCreateVM.value, 'firstName');
            const lastName = _.get(insuredCreateVM.value, 'lastName');
            // const passport = _.get(insuredCreateVM.value, 'passportNumber');
            // const saId = _.get(insuredCreateVM.value, 'id');
            return !((firstName && firstName.length >= 3) && (lastName && lastName.length >= 3) && insuredCity);
            // && (passport || saId)));
        }
        return true;
    };

    const overrides = {
        selectInsuredRadioButton: {
            visible: true,
            value: insuredType,
            availableValues: [
                {
                    iconName: 'building',
                    code: 'InsuredCompany_EXT',
                    name: {
                        id: 'fnol.common.policy-select-insured.Company',
                        defaultMessage: 'Company'
                    }
                },
                {
                    iconName: 'user',
                    code: 'InsuredContact_Ext',
                    name: {
                        id: 'fnol.common.policy-select-insured.Person',
                        defaultMessage: 'Person'
                    }
                }]
        },
        noPoliciesFoundNotification: {
            visible: shouldShowInfoNotification()
        },
        createInsuredRadioButton: {
            visible: true,
            value: insuredType
        },
        whenDidLossOccur: {
            defaultValue: new Date()
        },
        policyTable: {
            data: policyList,
            visible: policyList.length > 0
        },
        insuredTable: {
            data: insuredList,
            visible: insuredList.length > 0
        },
        // createInsured:{
        //     visible: createInsured
        // },
        policySelectRadio: {
            option: generateDataForRadioButton,
            value: (!_.isEmpty(claimVM.value) && _.get(claimVM.value, 'policy.policyNumber')),
            onValueChange: handlePolicySelect
        },
        insuredSelectRadio: {
            option: generateDataForInsuredRadioButton,
            value: (!_.isEmpty(policySearchCriteriaVM.value) && _.get(policySearchCriteriaVM.value, 'selectedInsured_EXT.uid')),
            onValueChange: handleInsuredSelect
        },
        sasriaClassCodeList: {
            availableValues: sasriaClassCodeData,
            value: sasriaClassCodeValue
        },
        searchPolicy: {
            disabled: !(_.get(policySearchCriteriaVM.value, 'policyNumber') && sasriaClassCodeValue && _.get(policySearchCriteriaVM.value, 'agentClaimNumber_EXT') && selectedInsured)
        },
        createInsuredCompanyContainer: {
            visible: showCreateDiv
        },
        cancelCreateInsuredButton: {
            visible: showCreateDiv
        },
        createInsuredLink: {
            visible: !showCreateDiv && createInsured
        },

        noInsuredFoundNotification: {
            visible: !showCreateDiv && createInsured
        },
        searchButton: {
            visible: !showCreateDiv,
            disabled: !((insuredType === 'InsuredCompany_EXT' && _.get(insuredSearchVM.value, 'companyName') && _.get(insuredSearchVM.value, 'companyName').length >= 3)
            || (insuredType === 'InsuredContact_Ext' && _.get(insuredSearchVM.value, 'firstName') && _.get(insuredSearchVM.value, 'firstName').length >= 3 && _.get(insuredSearchVM.value, 'lastName') && _.get(insuredSearchVM.value, 'lastName').length >= 3))
        },
        createInsuredButton: {
            visible: showCreateDiv,
            disabled: createInsuredButtonDisabled()
        },
        insuredTitle: {
            visible: !showCreateDiv
        },

        searchInsuredCompany: {
            path: policySearchCriteriaVM,
            insuredPath: insuredSearchVM,
            claimPath: claimVM,
            visible: insuredType === 'InsuredCompany_EXT' && !showCreateDiv,
            updatePath: updateWizardData,
            setInsuredTypeValue: setInsuredType
        },
        createInsuredCompany: {
            path: policySearchCriteriaVM,
            insuredPath: insuredCreateVM,
            claimPath: claimVM,
            visible: insuredType === 'InsuredCompany_EXT',
            updatePath: updateWizardData,
            setInsuredTypeValue: setInsuredType
        },
        searchInsuredContact: {
            path: policySearchCriteriaVM,
            insuredPath: insuredSearchVM,
            claimPath: claimVM,
            visible: insuredType === 'InsuredContact_Ext' && !showCreateDiv,
            updatePath: updateWizardData,
            setInsuredTypeValue: setInsuredType
        },
        createInsuredContact: {
            path: policySearchCriteriaVM,
            insuredPath: insuredCreateVM,
            claimPath: claimVM,
            visible: insuredType === 'InsuredContact_Ext',
            updatePath: updateWizardData,
            setInsuredTypeValue: setInsuredType
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            switchToManualSearchMode: switchToManualSearchMode,
            getInsuredTypeComponent: getInsuredTypeComponent,
            getFormattedDate: getFormattedDate,
            getProductImage: getProductImage,
            getCell: getCell,
            onSearchClicked: searchPolicyByPolicyNumber,
            onSearchInsuredClicked: searchInsured,
            onClickCreateInsured: createInsuredData,
            onClassCodeSelection: handleClassCodeChange,
            showCreateInsuredDiv: setCreateButtonVisibility
        },
        resolveComponentMap: {
            insuredCompanyComponent: SasriaInsuredCompany,
            insuredContactComponent: SasriaInsuredContact,
            createInsuredCompanyComponent: SasriaInsuredCompanyCreate,
            createInsuredContactComponent: SasriaInsuredContactCreate
        }
    };

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    return (
        <WizardPage
            showPrevious={false}
            // disableNext={!isComponentValid}
            disableNext={hideNext}
            onNext={onNext}
            template={WizardPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={policySearchCriteriaVM}
                onModelChange={handlePolicyCriteriaVMChange}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

FNOLSelectPolicy.propTypes = {
    ...wizardProps,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};

export default withRouter(FNOLSelectPolicy);
